<template>
  <v-dialog
    @input="v => v || onClose()"
    v-model="showDialog"
    scrollable
    transition="dialog-bottom-transition"
    width="500">
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        New Client
      </v-card-title>
      <v-card-text class="scheduler-modal__card-text">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field label="First Name" v-model="firstName" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Last Name" v-model="lastName" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Phone" v-model="inputedPhone" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Email" v-model="email" required></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="onClose">Cancel</v-btn>
        <v-btn color="blue darken-1" flat @click.native="onSave">Save and Book Appointment</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import clientService from '@/framework/client/clientService'

export default {
  props: {
    phone: {
      type: String
    },
    showDialog: {
      type: Boolean
    }
  },
  data: () => {
    return {
      email: '',
      firstName: '',
      lastName: '',
      inputedPhone: ''
    }
  },
  computed: {
    ...mapGetters({
      location: 'user/getLocation'
    })
  },
  created () {
    this.inputedPhone = this.phone
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    async onSave () {
      let res = await clientService.createClient({ firstName: this.firstName, lastName: this.lastName, phone: this.phone, email: this.email, locationId: this.location.id })
      this.$emit('saved', { Id: res.data, phone: this.phone })
      this.onClose()
    }
  }
}
</script>

<style>

</style>
